/**
 * 숫자를 한국 원화 단위로 포맷팅합니다
 */
export function formatKoreanCurrency(amount: number): string {
  return new Intl.NumberFormat('ko-KR', {
    style: 'currency',
    currency: 'KRW',
    maximumFractionDigits: 0
  }).format(amount);
}

/**
 * 날짜를 한국 날짜 형식으로 포맷팅합니다
 */
export function formatKoreanDate(dateString: string): string {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

/**
 * 숫자를 억 단위로 포맷팅합니다 (예: 25000000 -> 2,500만원)
 */
export function formatToKoreanUnit(amount: number): string {
  if (amount >= 100000000) {
    const eok = Math.floor(amount / 100000000);
    const man = Math.floor((amount % 100000000) / 10000);
    if (man > 0) {
      return `${eok}억 ${man.toLocaleString()}만원`;
    }
    return `${eok}억원`;
  } else if (amount >= 10000) {
    const man = Math.floor(amount / 10000);
    return `${man.toLocaleString()}만원`;
  } else {
    return `${amount.toLocaleString()}원`;
  }
} 